import { html, unsafeCSS } from 'lit'
import { customElement, property } from 'lit/decorators.js'

import { DdsElement } from '@/internal/dds-hu-element'

import styles from './overlay.scss?inline'

/**
 * `dap-ds-overlay`
 * @summary An overlay is a container for overlay content.
 * @element dap-ds-overlay
 * @title - Overlay
 *
 * @csspart overlay - The overlay element
 *
 * @cssproperty --dds-overlay-z-index - Controls the z-index of the overlay (default: 1)
 * @cssproperty --dds-overlay-background-color - Controls the background color of the overlay (default: var(--dds-black-10))
 * @cssproperty --dds-overlay-opacity-closed - Controls the opacity when overlay is closed (default: 0)
 * @cssproperty --dds-overlay-opacity-open - Controls the opacity when overlay is open (default: 1)
 */
@customElement('dap-ds-overlay')
export default class DapDSOverlay extends DdsElement {
  /** The open state of the overlay. */
  @property({ type: Boolean, reflect: true }) open?: boolean

  static readonly styles = unsafeCSS(styles)

  render() {
    return html`<slot></slot>`
  }
}
